import React, { useState } from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import NavBar from '../NavBar';
import SideBar from '../SideBar';
import Cookies from 'js-cookie';
import { useNavigateToRoute } from 'utils/common';
import AutoLogout from 'utils/AutoLogout';
import usePushNotifications from 'app/hooks/usePushNotifications';
import { useNotificationApi } from 'app/hooks/useNotificationApi';
import ReactNotificationComponent from '../Notifications/ReactNotification';
import useLoginApi from 'app/hooks/useLoginApi';
const HomeLayout = () => {
  const { tokenFound, currentNotificationToken } = usePushNotifications();
  const { useSendNotificationToken } = useNotificationApi();
  const { getMessage } = usePushNotifications();
  const [show, setShow] = React.useState(false);
  const [notification, setNotification] = React.useState({
    title: '',
    body: '',
  });
  const sendTokenMutation = useSendNotificationToken();
  const Authorization = Cookies.get('access_token')
    ? `Bearer ${Cookies.get('access_token')}`
    : '';
  const [isMobileView, setIsMobileView] = useState(true);
  const [isInsideView, setIsInsideView] = useState(false);
  const redirect = useNavigateToRoute();

  const userDetails = JSON.parse(Cookies.get('userDetails') || '{}');
  const token = sessionStorage.getItem('notificationTokenSent') ?? '';
  const { useLogout } = useLoginApi();
  const logoutMutation = useLogout({
    userId: userDetails.id,
    token: token,
  });
  const handleRecall = () => {
    Cookies.remove('access_token');
    Cookies.remove('refreshToken');
    Cookies.remove('tokenExpiry');
    sessionStorage.removeItem('isChangesDone');
    sessionStorage.removeItem('notificationTokenSent');
    localStorage.clear();
  };

  React.useEffect(() => {
    const accessToken = Cookies.get('access_token');
    if (accessToken) {
      getMessage(payload => {
        // Handle incoming message
        setNotification({
          title: payload.notification.title,
          body: payload.notification.body,
        });
        setShow(true);
        Cookies.set('isRefetchNotification', 'true');
      });
    } else {
      setShow(false);
    }

    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  React.useEffect(() => {
    if (tokenFound && currentNotificationToken) {
      const tokenSent = sessionStorage.getItem('notificationTokenSent');

      if (!tokenSent || tokenSent !== currentNotificationToken) {
        sendTokenMutation.mutate(undefined, {
          onSuccess: () => {
            sessionStorage.setItem(
              'notificationTokenSent',
              currentNotificationToken,
            );
          },
        });
      }
    }
  }, [currentNotificationToken, tokenFound]);

  React.useEffect(() => {
    // Check if the Outlet content contains the "inside-view" class
    const outletElement = document.querySelector('.inside-page-wrapper');
    setIsInsideView(!!outletElement);
  }, [isMobileView]);
  React.useEffect(() => {
    if (!Authorization) {
      redirect('/login');
    }
  }, [Authorization]);
  return (
    <Wrapper>
      {show ? (
        <ReactNotificationComponent
          title={notification.title}
          body={notification.body}
          showToast={show}
          setShowToast={setShow}
        />
      ) : (
        <></>
      )}
      {/* Custom configuration */}
      <AutoLogout
        to="/custom-logout"
        delayInSeconds={1800} // 30 minutes
        onLogout={() => {
          if (token) {
            logoutMutation.mutate(handleRecall());
          } else {
            handleRecall();
          }
        }}
      />
      {isMobileView ? (
        <>
          <MobileScreenWrapper>
            {!isInsideView && <SideBar />}
            <NavBar isMobileView={isMobileView} />
          </MobileScreenWrapper>
          <MobilePageWrapper className="common-page-wrapper">
            <Outlet />
          </MobilePageWrapper>
        </>
      ) : (
        <>
          <HeaderWrapper>
            <NavBar />
          </HeaderWrapper>
          <PageWrapper className="common-page-wrapper">
            <SideBar />
            <PageContentWrapper>
              <Outlet />
            </PageContentWrapper>
          </PageWrapper>
        </>
      )}
    </Wrapper>
  );
};

export default HomeLayout;
const Wrapper = styled.div``;
const HeaderWrapper = styled.div`
  @media (max-width: 768px) {
    background-size: cover;
    background-position: center;
    height: 108px;
  }
`;

const MobileScreenWrapper = styled.div`
  display: flex;
  padding-top: 10px;

  @media (max-width: 768px) {
    background: transparent;
    background-size: cover;
    background-position: center;
    height: 64px;
  }
`;

const PageWrapper = styled.div`
  display: flex;
  height: calc(100vh - 47px);
  width: 100%;
`;

const PageContentWrapper = styled.div`
  width: calc(100% - 80px);
  overflow: auto;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: ${p => p.theme.layoutPageScrollColor};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    width: 9px;
    background: ${p => p.theme.layoutPageScrollThumbColor};
    border-radius: 10px;
  }
`;

const MobilePageWrapper = styled.div`
  width: 100%;
`;
